import React, { Component } from 'react';
import _ from 'lib/lodash'
// import { copyTextToClipboard } from 'lib/utils'

import ACL from 'components/common/ACL'
import FontIcon from 'react-md/lib/FontIcons/FontIcon';
import ListItem from 'react-md/lib/Lists/ListItem';
import Divider from 'react-md/lib/Dividers'
import MenuButton from 'react-md/lib/Menus/MenuButton'
import Button from 'react-md/lib/Buttons'

import TextFieldEdit from 'components/common/TextFieldEdit'

import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'

import './LinkCardItem.css'

class LinkCardItem extends Component {
	state = {
		isEditing: false,
	};

	handleMenuOpen = (e) => {
		const { node } = this.props;
		const fileUrl = _.get(node, 'properties.url');

		if (fileUrl) window.open(fileUrl);
	};

	handleMenuEdit = () => this.setState({ ...this.state, isEditing: true });

	handleMenuEditExit = () => {
		const { actionHandler } = this.props;

		this.setState({...this.state, isEditing: false});
		actionHandler.addToast("Änderungen gespeichert");
	};

	handleMenuDelete = e => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload, addToast } = actionHandler;

		deleteNodeFromPayload(node).then(() => addToast("Link gelöscht"));
	};

	/*handleMenuCopy = () => {
		const { node, actionHandler } = this.props;

		try {
			copyTextToClipboard(node.properties.url);
			actionHandler.addToast(`Link kopiert.`);
		} catch (err) {
			actionHandler.addToast(`Link konnte leider nicht kopiert werden.`);
		}
	};*/

	updateProperty = (property) => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	componentDidMount() {
		const { node } = this.props;
		const { properties } = node;

		if (!properties.title) this.setState({ ...this.state, isEditing: true})
	}

	render() {
		const { node, actionHandler, aclAllow } = this.props;
		const { nodeHandler } = actionHandler;
		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;
		const { properties } = node;
		const { isEditing } = this.state;

		const { title, subtitle, url } = properties;

		const menuItems = [
			<ACL allow={aclAllow.edit} key="admin">
				{ isEditing && <ListItem
					key="open"
					primaryText="Link öffnen"
					leftIcon={<FontIcon>link</FontIcon>}
					onClick={this.handleMenuOpen}
				/> }
				{ isEditing && <Divider /> }
				<ListItem
					primaryText="Löschen"
					leftIcon={<FontIcon>delete</FontIcon>}
					onClick={this.handleMenuDelete} />
			</ACL>
		];

		const renderMenu = () => (
			<ACL allow={aclAllow.edit}>
				<div className="card-button-container">
					{ !isEditing && <Button icon onClick={this.handleMenuEdit}>edit</Button> }
					{ isEditing && <Button icon className="icon-done-top" onClick={this.handleMenuEditExit}>done</Button> }
					<MenuButton
						key="menu"
						id={`vert-menu${node.$id}`}
						icon
						menuItems={menuItems}
						simplifiedMenu={false}
						anchor={{
							x: MenuButton.HorizontalAnchors.LEFT,
							y: MenuButton.VerticalAnchors.OVERLAP,
						}}
					>
						<FontIcon>more_vert</FontIcon>
					</MenuButton>
				</div>
			</ACL>
		);

		const renderActionButtons = () => (
			<div className="link-actions">
				<FontIcon onClick={this.handleMenuOpen}>link</FontIcon>
			</div>
		);

		const renderTitle = () => (
			<div>
				{ isEditing && <TextFieldEdit
					id="title-field-link"
					type="title"
					label="Titel"
					value={title}
					onSubmit={value => this.updateProperty({ title: value })}
				/> }
				{ !isEditing && title && <a href={url} id={`node:${node.$id}:link:${title}`} target="_blank" rel="noopener noreferrer" className="link">{title}</a> }
			</div>
		);

		const renderSubtitle = () => (
			<div>
				{ isEditing && <TextFieldEdit
					id="subtitle-field-link"
					type="subtitle"
					label="Beschreibung"
					value={subtitle}
					onSubmit={value => this.updateProperty({ subtitle: value })}
				/> }
				{ isEditing && <TextFieldEdit
					id="url-field-link"
					type="url"
					label="Adresse (URL)"
					value={url}
					onSubmit={value => this.updateProperty({ url: value })}
				/> }
				{ !isEditing && subtitle }
			</div>
		);

		const renderContent = () => (
			<div className="link-card-item" id={node.$id}>
				<ListItem
					ref={c => this.listItem = c}
					primaryText={renderTitle()}
					secondaryText={renderSubtitle()}
					leftIcon={renderActionButtons()}
					rightIcon={renderMenu()}
					disabled

				>
				</ListItem>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Link wird gelöscht..." />;

		return (
			<div className="link-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="link-card-item-divider"/>
			</div>
		)
	}
}

export default LinkCardItem;



// WEBPACK FOOTER //
// ./src/components/cards/link/v1/LinkCardItem.jsx